import { render, staticRenderFns } from "./internshipdetails.vue?vue&type=template&id=7df6cef5&scoped=true&"
import script from "./internshipdetails.vue?vue&type=script&lang=js&"
export * from "./internshipdetails.vue?vue&type=script&lang=js&"
import style0 from "./internshipdetails.vue?vue&type=style&index=0&id=7df6cef5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df6cef5",
  null
  
)

export default component.exports